import { store } from '@/app/store.ts';
import { ThemeProvider } from '@arsnovasystems/ars-front-lib';
import { CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { Router } from './app/Router';

/**
 * @returns the application
 */
const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <CssBaseline />
        <RouterProvider router={Router} />
      </ThemeProvider>
    </Provider>
  );
};

export default App;
